import SeekTime from './seek_time'
export default SeekTime



// WEBPACK FOOTER //
// ./src/plugins/seek_time/index.js